// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var Hero = require("./Hero.bs.js");
var Store = require("../store.bs.js");
var React = require("react");
var Button = require("./Button.bs.js");

var buttons = Css.style(/* :: */[
      Css.display(/* flex */-1010954439),
      /* :: */[
        Css.selector("&:last-of-type", /* :: */[
              Css.selector("& :first-of-type", /* :: */[
                    Css.flexBasis(Css.pct(50)),
                    /* :: */[
                      Css.paddingLeft(Css.em(0.9)),
                      /* :: */[
                        Css.textAlign(/* left */-944764921),
                        /* [] */0
                      ]
                    ]
                  ]),
              /* [] */0
            ]),
        /* [] */0
      ]
    ]);

var calculator = Css.style(/* :: */[
      Css.background(Css.hex("838383")),
      /* :: */[
        Css.borderRadius(Css.px(5)),
        /* :: */[
          Css.overflow(Css.hidden),
          /* :: */[
            Css.width(Css.em(14)),
            /* [] */0
          ]
        ]
      ]
    ]);

var container = Css.style(/* :: */[
      Css.alignItems(/* center */98248149),
      /* :: */[
        Css.display(/* flex */-1010954439),
        /* :: */[
          Css.flexDirection(/* column */-963948842),
          /* [] */0
        ]
      ]
    ]);

var display = Css.style(/* :: */[
      Css.alignItems(Css.center),
      /* :: */[
        Css.color(Css.hex("fafafa")),
        /* :: */[
          Css.display(/* flex */-1010954439),
          /* :: */[
            Css.fontSize(Css.em(1.5)),
            /* :: */[
              Css.height(Css.em(2.5)),
              /* :: */[
                Css.justifyContent(Css.flexEnd),
                /* :: */[
                  Css.padding2(Css.zero, Css.em(1)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var Styles = /* module */[
  /* buttons */buttons,
  /* calculator */calculator,
  /* container */container,
  /* display */display
];

function App(Props) {
  var display$1 = Store.useDisplay(/* () */0);
  return React.createElement("div", {
              className: container
            }, React.createElement(Hero.make, { }), React.createElement("div", {
                  className: calculator
                }, React.createElement("label", {
                      className: display
                    }, display$1, React.createElement("input", {
                          type: "hidden"
                        })), React.createElement("div", {
                      className: buttons
                    }, React.createElement(Button.make, {
                          action: /* Clear */1,
                          text: "C"
                        }), React.createElement(Button.make, {
                          action: /* PosNeg */7,
                          text: "+/\u2212"
                        }), React.createElement(Button.make, {
                          action: /* Percent */8,
                          text: "%"
                        }), React.createElement(Button.make, {
                          action: /* Divide */2,
                          text: "\u00f7"
                        })), React.createElement("div", {
                      className: buttons
                    }, React.createElement(Button.make, {
                          action: /* Input */["7"],
                          text: "7"
                        }), React.createElement(Button.make, {
                          action: /* Input */["8"],
                          text: "8"
                        }), React.createElement(Button.make, {
                          action: /* Input */["9"],
                          text: "9"
                        }), React.createElement(Button.make, {
                          action: /* Multiply */5,
                          text: "\u00d7"
                        })), React.createElement("div", {
                      className: buttons
                    }, React.createElement(Button.make, {
                          action: /* Input */["4"],
                          text: "4"
                        }), React.createElement(Button.make, {
                          action: /* Input */["5"],
                          text: "5"
                        }), React.createElement(Button.make, {
                          action: /* Input */["6"],
                          text: "6"
                        }), React.createElement(Button.make, {
                          action: /* Subtract */6,
                          text: "\u2212"
                        })), React.createElement("div", {
                      className: buttons
                    }, React.createElement(Button.make, {
                          action: /* Input */["1"],
                          text: "1"
                        }), React.createElement(Button.make, {
                          action: /* Input */["2"],
                          text: "2"
                        }), React.createElement(Button.make, {
                          action: /* Input */["3"],
                          text: "3"
                        }), React.createElement(Button.make, {
                          action: /* Add */0,
                          text: "+"
                        })), React.createElement("div", {
                      className: buttons
                    }, React.createElement(Button.make, {
                          action: /* Input */["0"],
                          text: "0"
                        }), React.createElement(Button.make, {
                          action: /* Input */["."],
                          text: "."
                        }), React.createElement(Button.make, {
                          action: /* Equals */3,
                          text: "="
                        }))));
}

var make = App;

exports.Styles = Styles;
exports.make = make;
/* buttons Not a pure module */
